import {
  API_ROUTE_REPLACE_COMPANY_KEY,
  API_ROUTE_REPLACE_PARTNER_KEY,
  ApiRouteKeys
} from '@constants/api-routes.constant';

export enum GIApiRouteKeys {
  contracts = 'contracts',
  prospects = 'prospects',
  emailTemplates = 'email_templates',
  contractAnnexModels = 'contract_annex_models',
  dashboards = 'dashboards'
}

export const GI_API_ROUTE_BASE = 'api/v1/expert/gi';
export const GI_COMPANY_API_ROUTE_BASE = `${GI_API_ROUTE_BASE}/${ApiRouteKeys.companies}/${API_ROUTE_REPLACE_COMPANY_KEY}`;
export const GI_PARTNER_API_ROUTE_BASE = `${GI_API_ROUTE_BASE}/${ApiRouteKeys.partners}/${API_ROUTE_REPLACE_PARTNER_KEY}`;

export const GI_API_ROUTES = {
  contracts: `${GI_API_ROUTE_BASE}/${GIApiRouteKeys.contracts}`,
  companyContracts: `${GI_COMPANY_API_ROUTE_BASE}/${GIApiRouteKeys.contracts}`,
  prospects: `${GI_API_ROUTE_BASE}/${GIApiRouteKeys.prospects}`,
  companyProspects: `${GI_COMPANY_API_ROUTE_BASE}/${GIApiRouteKeys.prospects}`,
  partnerEmailTemplates: `${GI_PARTNER_API_ROUTE_BASE}/${GIApiRouteKeys.emailTemplates}`,
  partnerContractAnnexModels: `${GI_PARTNER_API_ROUTE_BASE}/${GIApiRouteKeys.contractAnnexModels}`,
  opportunitiesDashboards: `${GI_API_ROUTE_BASE}/${GIApiRouteKeys.dashboards}`
};

export const GI_API_HEADERS = {
  contractFileTypeV2: 'application/vnd.tiime.expert.gi.contract.file.type.v2+json',
  contractStatusV2: 'application/vnd.tiime.expert.gi.contract.status.v2+json'
};

export const GI_API_ROUTE_EXPAND = {
  gITaskCategories: 'gi_task_categories'
};
